import { HeadSEO } from "../../components/SEO/HeadSEO";
import * as StyledLayout from "../../layouts/Styled.Layout";
import * as StyledTypography from "../../styles/Styled.Typography";
import { ArticleArchive } from "@/components/ArticleArchive";

export default function ArticleArchivePage() {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "Stanley Yeo",
    url: "https://stanleyyeo.com",
  };
  return (
    <>
      <HeadSEO
        siteTitle="Articles"
        siteDescription="Read insights and guides on web design, WordPress, and branding—practical tips for business owners and designers alike."
        structuredData={structuredData}
      />
      <StyledTypography.ParadoxSubtitle as="h2" data-animate="fade-up">
        Views might be wrong, but at least they’re not boring.
      </StyledTypography.ParadoxSubtitle>
      <StyledLayout.Grid>
        <StyledLayout.GridItem>
          <p data-animate="fade-up">
            The articles here are usually about building a personal brand and
            diversifying income streams but with a caveat - flipping the
            overwhelming consensus on the means to an end to an end in itself.
            In addition, the inauguration of your success; however you define
            it, would largely mean noticeable changes from where you are at
            present to where you want to be. And to narrow the gap, you’ll need
            confirming evidence to support your contention. So let the ramblings
            of these articles, invoke your sense of discovery in all sorts of
            contexts, and expand your ability to question conventional wisdom.
            Once you’ve put your filters in working order, I think you can
            probably approach a new level of equilibrium in work and life.
          </p>
          <p data-animate="fade-up">
            The bedrock of my work is to address one primary question - is what
            you are doing today making you a better creative than you were
            yesterday?
          </p>
          <p data-animate="fade-up">
            If I’m being honest, it helps you to know this is where I willingly
            practise putting myself in embarrassing situations to discuss a wide
            range of topics I think I know and yet don’t. And before you decide
            anything I say is nonsensical, ill-advised, or ridiculously
            impractical in any particular idea, there’s a healthy chance you are
            right. On top of that, I’m not an advisor or mentor. If you’ve ever
            taken advice from a designer, it probably didn’t end well.
          </p>
          <p data-animate="fade-up">
            I am not too proud to say these articles you are about to read
            aren’t entirely my idea. In fact, they are built on the work of
            others (In articles which I refer to studies, I’ll give due credit
            to my sources), making it discernible for you to digest, apply and
            build on in your creative work. I don’t need to prove my credibility
            so long as I do my job well. If it didn’t work out for you, the most
            sensible reason is that these articles aren’t designed to be a
            one-size-fits-all solution that can be applied to your specific
            situation.
          </p>
          <p data-animate="fade-up">
            Expect to see opinions you are likely to agree with and other
            thoughts which you will be certain are woefully wrong. We can’t
            agree on everything here. If we could, everything you read on this
            website would have been superfluous. Compare for yourself what you
            find here with resources elsewhere. You are the best judge to know
            what works for you.
          </p>
          <p data-animate="fade-up">
            By any objective measure, I’m certainly not an expert in any of the
            topics you’re going to find on my website, and I have to admit I
            won’t always have the right formula. But hey, nothing is absolute,
            and that’s what life is about, right? Navigating the world with
            complete certainty as though we understood it.
          </p>
          <p data-animate="fade-up">
            Now you are warned. I recommend taking what you read with a grain of
            salt. Enjoy.
          </p>
        </StyledLayout.GridItem>
        <StyledLayout.GridItem>
          <ArticleArchive />
        </StyledLayout.GridItem>
      </StyledLayout.Grid>
    </>
  );
}
